// material-ui
import { Box, FormControl, InputAdornment, OutlinedInput } from '@mui/material';

// assets
import { SearchOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import {
  actions as routeActions,
  types as routes
} from '../../../../reducers/rotas.actions';
import { activeItem } from 'reducers/menu';

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

const SearchMobile = () => {
  const dispatch = useDispatch();

  const queryString = useSelector((state) => state.pesquisa.queryString);

  const [query, setQuery] = useState('');

  const handleSearch = () => {
    if (query === '') return;
    dispatch(activeItem({ openItem: [null] }));
    dispatch(
      routeActions.redirectTo(routes.PESQUISA, {
        termo: query.replaceAll('/', ' ')
      })
    );
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  useEffect(() => {
    setQuery(queryString);
  }, [queryString]);

  return (
    <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }}>
      <FormControl sx={{ width: { xs: '100%' } }}>
        <OutlinedInput
          value={query}
          size="small"
          id="header-search"
          startAdornment={
            <InputAdornment position="start" sx={{ mr: -0.5 }}>
              <SearchOutlined />
            </InputAdornment>
          }
          aria-describedby="header-search-text"
          inputProps={{
            'aria-label': 'weight'
          }}
          placeholder="Pesquisar"
          onBlur={handleSearch}
          onKeyPress={handleKeyPress}
          onChange={(e) => setQuery(e.target.value)}
        />
      </FormControl>
    </Box>
  );
};

export default SearchMobile;
